import { Flex, Spinner } from "@chakra-ui/react";


export default function LaunchdeckButton(props) {
	
	const { label, w, width, onClick, border, borderColor, visibility, px, py, mx, hover, textTransform, dummy, bg, minW, fontSize, color, name, value, fontWeight, loadingLogic, transition= "" } = props;
	const isDummy = dummy ? true:false;
	const isFullWidth = (width==='100%' || w==='100%') ? true : false;

	
	return (
		<Flex
			display={!isFullWidth && 'inline-flex'}
			name={name ? name : ''}
			value={value ? value : ''}
			onClick={loadingLogic || isDummy ? null : onClick } 
			px={px ? px : "1em"}
			py={py ? py : '0.4em'}
			rounded='18.75em'
			fontSize={fontSize ? fontSize : "0.8em"}
			bg={bg ? bg : "#f5f6f7"}
			border= {border ? border : "1px solid"}
			borderColor={borderColor ? borderColor : bg ? bg : "brand.500"}
			color={color ? color : "#4b4f56"}
			textTransform={textTransform ? textTransform : ''}
			cursor={(isDummy || loadingLogic) ? 'default' : 'pointer'}
			w={width ? width : w ? w : ''}
			fontWeight={fontWeight ? fontWeight : '400'}
			textAlign='center'
			align={!label && 'center'}
			justifyContent='center'
			whiteSpace='pre'
			mx={mx && mx}
			minW= {minW || '8em'}
			visibility={visibility}
			transition={transition}
			_hover={(hover) && { color: "white", bg: "brand.500", fontWeight:"600" ,border:"1px solid", borderColor:'brand.200' }}
		>
			{loadingLogic ? <Flex minWidth='5em' justify='center' w='100%'><Spinner boxSize='1em' my='0.2em' mx='0.4em'/></Flex> : label ? label : props.children}		
		</Flex>

	)	
}